import(/* webpackMode: "eager", webpackExports: ["ForgotPasswordForm"] */ "/home/runner/_work/platform/platform/packages/dashboard/src/components/forms/forgot-password-form.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OnboardingFooter"] */ "/home/runner/_work/platform/platform/packages/dashboard/src/components/ui/onboarding/footer.tsx");
